import { BooleanFormField } from "@/app/components/form-fields/BooleanFormField";
import { DateFormField } from "@/app/components/form-fields/DateFormFeld";
import { FileFormField } from "@/app/components/form-fields/FileFormField";
import { NumberFormField } from "@/app/components/form-fields/NumberFormField";
import { SelectFormField } from "@/app/components/form-fields/SelectFormField";
import { UserFormField } from "@/app/components/form-fields/UserFormField";
import {
  commonFormFieldProps,
  requiredRule,
} from "@/app/fields/commonFormFieldProps";
import { Entity, IField, ISelectFieldOption } from "@/app/fields/types";
import { useGetNumberAddons } from "@/app/hooks/useGetNumberAddons";
import { Field } from "@saas-ui/react";
import { ReactElement } from "react";

export const SingleValueFormField = <T extends Entity>({
  field,
  options,
  isDisabled,
  onAddOption,
}: {
  field: IField<T>;
  options: ISelectFieldOption[];
  isDisabled?: boolean;
  onAddOption: (option: ISelectFieldOption) => void;
}): ReactElement => {
  const key = String(field.field);
  const getNumberAddons = useGetNumberAddons<T>();
  switch (field.type) {
    case "boolean":
      return <BooleanFormField field={field} isDisabled={isDisabled} />;
    case "date":
      return <DateFormField field={field} isDisabled={isDisabled} />;
    case "text":
      return (
        <Field
          isDisabled={isDisabled}
          type={field.is_textarea ? "textarea" : "text"}
          key={key}
          label={field.label}
          {...commonFormFieldProps(field)}
          rules={requiredRule(field)}
          placeholder={field.placeholder}
        />
      );
    case "number":
      return <NumberFormField field={field} isDisabled={isDisabled} />;
    case "select":
      return (
        <SelectFormField
          field={field}
          options={options}
          isDisabled={isDisabled}
          onAddOption={onAddOption}
        />
      );
    case "user":
      return <UserFormField field={field} isDisabled={isDisabled} />;
    case "file":
      return <FileFormField field={field} isDisabled={isDisabled} />;
  }
};
